'use client'

import type { ReactNode } from 'react'

import '../sections.css'

import parse from 'html-react-parser'

import useStore from '@/stores/Store'

interface JumbotronCashBizProps {
  badgeText?: ReactNode
  title: string
  buttonText?: ReactNode
  footNotes?: ReactNode
}

function JumbotronBiz({ badgeText, title, buttonText, footNotes }: JumbotronCashBizProps) {
  const { formRef } = useStore()

  return (
    <div className="background-color-cashbiz">
      <div className="background-img-cashbiz">
        <div className="container">
          <div className="jumbotron-container">
            <div className="jumbotron-title col-xl-2">{badgeText}</div>
            <div className="jumbotron-subtitle col-xl-6">{parse(title)}</div>
            {buttonText && (
              <button
                className="btn btn-primary btn-lg applybtn"
                type="button"
                onClick={() => {
                  if (formRef.current) {
                    const offset = 410 // Adjust this value as needed
                    const topPosition =
                      formRef.current.getBoundingClientRect().top + window.pageYOffset - offset
                    window.scrollTo({
                      top: topPosition,
                      behavior: 'smooth'
                    })
                  }
                }}
              >
                {buttonText}
              </button>
            )}
            {footNotes && (
              <div className="jumbotron-note">
                <i className="bi bi-shield" style={{ margin: '5px' }}></i>
                {footNotes}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default JumbotronBiz
